/**
 * The canonical "converting page" value, shared by the `formUrl:<value>;` entry
 * in the outgoing `experiment_exposures` payload (`appendFormUrlToExposures`)
 * and the `formUrl` property on Optimizely's `submit_lead_tracking_form` event.
 *
 * Returned raw — percent-encoding is a requirement of the delimited cookie
 * field, not of the value, so only that caller applies it. Search params and
 * hash are excluded: UTM noise, and they would blow the 255-char cookie cap.
 *
 * Returns null on the server or on any unexpected error; both callers run at
 * lead-submit time, so neither may throw.
 */
export const getFormUrl = (): string | null => {
    try {
        if (typeof window === 'undefined' || !window.location) {
            return null;
        }
        return window.location.hostname + window.location.pathname;
    } catch {
        return null;
    }
};
